import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { selectListItems } from "../../../../../../redux/tasks/selector";
import { tasks } from "../../../../../../redux/tasks/action";
import PageLoader from "../../../../../../components/PageLoader";
import { selectListItems as selectLibraryListItems } from "../../../../../../redux/library/selector";

const ManagementTasks = () => {
  const dispatch = useAppDispatch()
  const libraryData = useSelector(selectLibraryListItems)
  const itemsData = useSelector(selectListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'LogisticsTaskId', headerName: 'Task Id', sortable: true },
      { field: 'RoutePlanStopId', headerName: 'Stop Id', sortable: true },
      {
        field: 'LogisticsTaskStatusId', headerName: 'Task Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: {
          library: libraryData?.result?.LogisticsTaskStatus, isRowColorDecider: false
        },
        sortable: true,
        filter: false
      },
      {
        field: 'LogisticsTaskSubTypeId', headerName: 'TaskType Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: {
          library: libraryData?.result?.LogisticsTaskSubType, isRowColorDecider: false
        },
        sortable: true,
        filter: false
      },

      { field: 'CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'ModifiedOn', isDateValueFormat: true },

    ]);
  }

  useEffect(() => {
    createColumnDefs()
    dispatch(tasks.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/logistics-tasks/fetch`, entity: 'tasks', jsonData: {
        "Context": {},
        "Records": [
          {

          }
        ]
      }
    }))
  }, [])

  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} headingName="Tasks" />
      }
    </>

  );
};

export default ManagementTasks;


